"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenuinePartsWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var portal_core_1 = require("@ferry/portal-core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var GenuinePartsWidget = /** @class */ (function (_super) {
    __extends(GenuinePartsWidget, _super);
    function GenuinePartsWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenuinePartsWidget.prototype.render = function () {
        var brandName = (0, portal_core_1.getPrettifiedInteractionBrandName)(this.props.interaction.brandName);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "genuine-parts-banner-widget my-5", children: [(0, jsx_runtime_1.jsxs)("div", { className: "genuine-parts-banner-content", children: [(0, jsx_runtime_1.jsx)("img", { className: "genuine-parts-banner-tick", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/check-summary.svg"), alt: "" }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { className: "font-weight-bold mb-0", children: [brandName, " Genuine Parts"] }), (0, jsx_runtime_1.jsx)("p", { className: "mb-0", children: "In the event of a claim, we only use genuine parts for repairs - and each one comes with a two-year warranty, excluding wear and tear items." })] })] }), (0, jsx_runtime_1.jsx)("img", { className: "genuine-parts-banner-image", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/genuine-parts-banner.png"), alt: "A technician fitting ".concat(brandName, " Genuine Parts") })] }));
    };
    return GenuinePartsWidget;
}(plugin_journey_1.WidgetBase));
exports.GenuinePartsWidget = GenuinePartsWidget;
//# sourceMappingURL=GenuinePartsWidget.js.map